@if (!parcels.length && !loading) {
    <div class="text-center">
        <h2>Add parcels to view analysis</h2>
    </div>
}
@if (!annualData.length && parcels.length && !loading) {
    <div class="text-center">
        <h2>Add a year to a parcel to view analysis</h2>
    </div>
}
@if (loading) {
    <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
}
@if (annualData.length && !loading && parcels.length) {
    <div class="d-flex flex-grow-1 px-2 pt-3 overflow-y-auto">
        <div [ngClass]="getSummaryColumnClass()">
            <div class="pe-1">
                <form class="d-flex align-items-center mb-2">
                    <span class="d-flex align-items-center">
                        <label for="taxYear" class="me-2">Tax Year:</label>
                        <ws-select
                            [(ngModel)]="selectedYear"
                            name="taxYear"
                            [isPrimitive]="true"
                            [sizeToContent]="true"
                            [options]="availableYears | filter: filterYears | sortBy: 'asc'"
                            (ngModelChange)="getDataByYear(false)"
                        >
                        </ws-select>
                    </span>
                    @if (!(parcels.length === 1 || parcelId())) {
                        <span class="all-parcels d-inline-block">
                            <div class="clickable" (click)="openParcelFilter()" style="font-size: 13px">
                                <span style="color: var(--ace-success); font-weight: bold">{{
                                    parcelFilterList.length
                                }}</span>
                                of {{ parcels.length }}
                                parcels
                            </div>
                        </span>
                    }
                </form>
                <span class="activity-summary-table">
                    <activity-summary-table
                        [annualData]="annualData"
                        [propCharacteristics]="propertyCharacteristics"
                        [selectedYear]="selectedYear"
                    >
                    </activity-summary-table>
                </span>
            </div>
        </div>
        <div [ngClass]="getGraphColumnClass()" class="position-relative">
            <activity-chart [config]="activityData" [parcelId]="parcelId()"></activity-chart>
        </div>
    </div>
    <activity-deadline-footer [parcelId]="parcelId()" [siteId]="siteId()"></activity-deadline-footer>
}
